import React, { Component } from 'react'
import ParkingInfo from './parkingInfo.jsx'
import CommonInfo from './commonInfo.jsx'

class ProductInfo extends Component {
  constructor (props) {
    super(props)
    this.renderProductDetails = this.renderProductDetails.bind(this)
  }

  renderProductDetails () {
    const {
      productData,
      pageData: { productClass }
    } = this.props
    const { prices } = productData
    const productPrice = prices.per_week && prices.per_week.split('.').join(',')

    switch (productClass) {
      case 'CP':
        return <ParkingInfo productData={productData} productPrice={productPrice} />
      default:
        return <CommonInfo productData={productData} productPrice={productPrice} />
    }
  }

  render () {
    return (
      <div className='tab-content'>
        <div className='tab-panel active'>{this.renderProductDetails()}</div>
      </div>
    )
  }
}

ProductInfo.propTypes = {}

export default ProductInfo



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/de/productInfo.jsx